export const BASE_URL = 'https://api.alradwan-medical.com/api';
// export const BASE_URL = 'https://midad-api.beetronix.net/api';